import styled from "@emotion/styled";

export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
